module.exports = __webpack_public_path__ + "static/media/leopard_head_orientation_front.b4e545ca.jpeg";